import once from 'lodash/once'

export default function makeTrackReferrerMeta ({ authStore }) {
  return once(function onEnter (p) {
    const query = p.location.query

    const { ref, ...rest } = query
    if (ref) {
      rest.referrer = ref
    }

    authStore.setReferrerMeta(rest)
  })
}



// WEBPACK FOOTER //
// ./src/client/shell/AppRouter/interceptors/trackReferrerMeta.js